import {
  Container,
  Stack,
  List,
  ListItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Text } from "../components/Text";
import { Parentheses } from "../components/Parentheses";
import { MoreButton } from "../components/MoreButton";

export const Service = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack>
      <Stack
        justifyContent="center"
        sx={{
          backgroundImage: isMobile
            ? "url(/images/service-kv_sp.png)"
            : "url(/images/service-kv.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: isMobile ? 200 : 320,
        }}
      >
        <Container>
          <Text variant="h1" fontSize={40} color="primary">
            製品サービス
          </Text>
          <Text
            variant="h2"
            marginTop={1}
            color="primary"
            sx={{
              fontSize: isMobile ? "22px !important" : 28,
            }}
          >
            Products and Services
          </Text>
        </Container>
      </Stack>
      <Stack>
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                キット販売
              </Text>
              <Text marginTop={2} lineHeight={2}>
                MycoGenomeでは、当社独自の自律複製型ベクターを販売しています。研究機関や企業が手軽に微生物へのベクター導入が可能です。
              </Text>
              <Stack
                sx={{
                  background: "#006400",
                  color: "#fff",
                  width: "fit-content",
                  lineHeight: 1,
                  padding: "5px 14px",
                  marginTop: 2.6,
                }}
              >
                特徴
              </Stack>
              <List>
                {[
                  "ユーザーフレンドリー：研究者や企業のラボで簡単に利用可能",
                  "多様な菌種に対応：食品、農業、環境、バイオ燃料など幅広い分野で応用可能",
                ].map((text, index) => {
                  return (
                    <ListItem
                      key={index}
                      sx={{
                        padding: 0,
                        "&::before": {
                          content: "'⚫︎'",
                          color: "#ffbd00",
                          paddingRight: 1,
                        },
                      }}
                    >
                      <Text lineHeight={1.7} fontWeight="bold">
                        {text}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
            </Stack>
          </Parentheses>
          <Stack marginTop={1.5} alignItems="center">
            <MoreButton
              href="/contact?type=1"
              width={isMobile ? 300 : 380}
              right={25}
            >
              <Text lineHeight={isMobile ? 1.5 : 1} textAlign="center">
                ベクター販売に関する{isMobile ? <br /> : null}お問い合わせ
              </Text>
            </MoreButton>
          </Stack>
        </Container>
      </Stack>
      <Stack
        sx={{
          background: "#f6f6f6",
        }}
      >
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                共同研究
              </Text>
              <Text marginTop={2} lineHeight={2}>
                真菌ゲノム編集の新たな可能性を共に探求 <br />
                MycoGenomeは、企業や研究機関との共同研究を積極的に推進しています。食品発酵、バイオ燃料、医薬品生産などの分野において、当社のゲノム編集技術を活用し、新しい微生物の開発を支援します。
              </Text>
              <Stack
                sx={{
                  background: "#006400",
                  color: "#fff",
                  width: "fit-content",
                  lineHeight: 1,
                  padding: "5px 14px",
                  marginTop: 2.6,
                }}
              >
                共同研究の進め方
              </Stack>
              <List>
                {[
                  "課題のヒアリング：企業様の課題やニーズを丁寧にヒアリングし、最適な協業テーマ・研究テーマを設定します。",
                  "技術提供・実験設計：MycoEdita技術を活用した実験計画を立案し、最適なアプローチを提案します。",
                  "研究実施・データ解析：実験を進め、得られたデータを詳細に解析し、課題解決に向けた戦略を構築します。",
                  "成果の活用・商業化：得られた技術やデータの活用について、企業様と協議の上、最適な形での実用化を進めます。",
                ].map((text, index) => {
                  return (
                    <ListItem
                      key={index}
                      sx={{
                        padding: 0,
                        "&::before": {
                          content: `"${index + 1}"`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "20px",
                          height: "20px",
                          color: "#fff",
                          background: "#333333",
                          marginRight: 1,
                          borderRadius: 999,
                          lineHeight: 1,
                        },
                      }}
                    >
                      <Text lineHeight={1.7} fontWeight="bold">
                        {text}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
              <Stack marginTop={1.5} alignItems="center">
                <MoreButton
                  href="/contact?type=2"
                  width={isMobile ? 300 : 440}
                  right={25}
                >
                  <Text lineHeight={isMobile ? 1.5 : 1} textAlign="center">
                    共同研究の詳細・実績{isMobile ? <br /> : null}
                    についてのお問い合わせ
                  </Text>
                </MoreButton>
              </Stack>
            </Stack>
          </Parentheses>
        </Container>
      </Stack>
      <Stack>
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                受託研究
              </Text>
              <Text marginTop={2} lineHeight={2}>
                微生物ゲノム編集技術を活用した課題解決を推進します。
                <br />
                当社は、最先端の非遺伝子組換え型ゲノム編集技「MycoEdita」を活用し、企業や研究機関との委託研究を積極的に推進しています。食品発酵、バイオ燃料（SAF）、医薬品、環境分野など、多岐にわたる産業領域での応用が可能です。
              </Text>
              <Stack
                sx={{
                  background: "#006400",
                  color: "#fff",
                  width: "fit-content",
                  lineHeight: 1,
                  padding: "5px 14px",
                  marginTop: 2.6,
                }}
              >
                共同研究の進め方
              </Stack>
              <List>
                {[
                  "ヒアリング:お客様の研究課題やニーズを詳しくヒアリングし、最適な研究テーマを設定します。",
                  "研究計画の立案:当社の「MycoEdita」技術を活用した実験設計を行い、最適なアプローチを提案します。",
                  "研究実施・データ解析:実験を進め、得られたデータを詳細に解析。お客様と連携しながら最適な研究戦略を構築します。",
                  "成果の活用:得られた研究成果を、お客様の製品開発や事業に応じて実用化へとつなげます。",
                ].map((text, index) => {
                  return (
                    <ListItem
                      key={index}
                      sx={{
                        padding: 0,
                        "&::before": {
                          content: `"${index + 1}"`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "20px",
                          height: "20px",
                          color: "#fff",
                          background: "#333333",
                          marginRight: 1,
                          borderRadius: 999,
                          lineHeight: 1,
                        },
                      }}
                    >
                      <Text lineHeight={1.7} fontWeight="bold">
                        {text}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
            </Stack>
          </Parentheses>
          <Stack marginTop={1.5} alignItems="center">
            <MoreButton
              href="/contact?type=3"
              width={isMobile ? 300 : 440}
              right={25}
            >
              <Text lineHeight={isMobile ? 1.5 : 1} textAlign="center">
                受託研究の詳細・実績{isMobile ? <br /> : null}
                についてのお問い合わせ
              </Text>
            </MoreButton>
          </Stack>
        </Container>
      </Stack>
      <Stack
        sx={{
          background: "#f6f6f6",
        }}
      >
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                ベクター設計・構築
              </Text>
              <Text marginTop={2} lineHeight={2}>
                MycoGenomeでは、微生物のゲノム編集に必要なツールの設計・構築を提供しています。特定の遺伝子を自在に制御可能な設計を行います。
              </Text>
              <Stack
                sx={{
                  background: "#006400",
                  color: "#fff",
                  width: "fit-content",
                  lineHeight: 1,
                  padding: "5px 14px",
                  marginTop: 2.6,
                }}
              >
                サービスの内容
              </Stack>
              <List>
                {[
                  "標準ベクターの提供：すぐに利用できる形質転換ベクターの販売",
                  "カスタム設計：目的の遺伝子を組み込んだオーダーメイド設計",
                  "除去可能なベクター構築：外来DNAを残さずに微生物改変が可能",
                ].map((text, index) => {
                  return (
                    <ListItem
                      key={index}
                      sx={{
                        padding: 0,
                        "&::before": {
                          content: "'⚫︎'",
                          color: "#ffbd00",
                          paddingRight: 1,
                        },
                      }}
                    >
                      <Text lineHeight={1.7} fontWeight="bold">
                        {text}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
              <Stack marginTop={1.5} alignItems="center">
                <MoreButton
                  href="/contact?type=4"
                  width={isMobile ? 300 : 480}
                  right={25}
                >
                  <Text lineHeight={isMobile ? 1.5 : 1} textAlign="center">
                    詳細な仕様やカスタム設計{isMobile ? <br /> : null}
                    についてのお問合せ
                  </Text>
                </MoreButton>
              </Stack>
            </Stack>
          </Parentheses>
        </Container>
      </Stack>
    </Stack>
  );
};
